var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-exchange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.065,
    height: 20.803,
    viewBox: "0 0 20.065 20.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15326",
    "data-name": "Grupo 15326",
    transform: "translate(-115.5 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15325",
    "data-name": "Grupo 15325",
    transform: "translate(-7 -1.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(122.5 339.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15259",
    "data-name": "Grupo 15259",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15258",
    "data-name": "Grupo 15258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14511",
    "data-name": "Caminho 14511",
    d: "M19.342,75.293a.73.73,0,0,0-.712.6,8.584,8.584,0,0,1-1.086,2.736,13.008,13.008,0,0,0-2.727-1.439,6.069,6.069,0,0,0,.373-2.063c0-.207,0-.4-.016-.6a.723.723,0,0,0-1.442.109c.012.169.012.326.012.495a4.541,4.541,0,0,1-.3,1.607,12.817,12.817,0,0,0-6.636,0,11.5,11.5,0,0,1,0-5.214,11.455,11.455,0,0,0,3.959.161.724.724,0,1,0-.3-1.415c-1.7.365-1.505.292-3.228-.153a11.61,11.61,0,0,1,2.9-4.4c.058.055.12.107.176.162a.726.726,0,0,0,1.306-.441v-.3l-.01-.01a.7.7,0,0,0,.093-.285.723.723,0,0,0-.647-.793c-.291-.029-.571-.042-.862-.043h-.014c-.017,0-.032,0-.049,0A10.109,10.109,0,0,0,2,68.111a.473.473,0,0,0-.051.043.588.588,0,0,0-.038.074,10.057,10.057,0,0,0,0,11.8.729.729,0,0,0,.038.075c.014.019.035.026.051.043a10.06,10.06,0,0,0,16.182.055.668.668,0,0,0,.123-.1.712.712,0,0,0,.108-.214,10,10,0,0,0,1.638-3.717l.014-.161A.717.717,0,0,0,19.342,75.293ZM8.2,65.655A13.017,13.017,0,0,0,5.86,69.662a11.521,11.521,0,0,1-2.284-1.2A8.688,8.688,0,0,1,8.2,65.655ZM2.715,78.622a8.583,8.583,0,0,1,0-8.987,13.1,13.1,0,0,0,2.715,1.432,12.752,12.752,0,0,0,0,6.119A13.041,13.041,0,0,0,2.715,78.622Zm.848,1.169a11.653,11.653,0,0,1,2.289-1.217A13.006,13.006,0,0,0,8.185,82.58,8.687,8.687,0,0,1,3.563,79.79Zm6.564,2.743a11.581,11.581,0,0,1-2.9-4.417,11.457,11.457,0,0,1,5.8,0A11.581,11.581,0,0,1,10.127,82.533Zm1.965.017A13.018,13.018,0,0,0,14.4,78.574,11.6,11.6,0,0,1,16.69,79.79,8.728,8.728,0,0,1,12.091,82.551Z",
    transform: "translate(0 -64)",
    fill: "#0f1824"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "wire-transfer",
    d: "M12.617,17.271a.681.681,0,0,0,.681-.681v-.567a2.194,2.194,0,0,0,.572-4.272L11.8,11.06a.836.836,0,0,1,.265-1.629h.9a1.127,1.127,0,0,1,1.071.772.681.681,0,0,0,1.293-.431A2.486,2.486,0,0,0,13.3,8.1V7.512a.681.681,0,0,0-1.362,0v.567a2.193,2.193,0,0,0-.572,4.272l2.075.691a.836.836,0,0,1-.265,1.629h-.9A1.129,1.129,0,0,1,11.2,13.9a.681.681,0,1,0-1.292.431,2.484,2.484,0,0,0,2.028,1.676v.584a.681.681,0,0,0,.681.681Z",
    transform: "translate(118.927 330.169)",
    fill: "#898d92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExchange);
export default __webpack_public_path__ + "static/media/ico-exchange.0ee84979bc45ffa3ad6c66f0a0be7080.svg";
export { ForwardRef as ReactComponent };